import { render, staticRenderFns } from "./TextH1.vue?vue&type=template&id=369bbcf0"
import script from "./TextH1.vue?vue&type=script&lang=js"
export * from "./TextH1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports